import React, { useEffect, useState, ReactNode } from 'react';
import { isChrome, isMobile } from 'react-device-detect';
import { UnsupportedBrowserAlert } from '@/components';
import { NavigationPath } from '@/router/navigation-path.ts';

const EXCLUDED_PATHS = [NavigationPath.createAccount, NavigationPath.landingPage];

const isWhitelistedPath = (pathname: string): boolean => {
	return EXCLUDED_PATHS.some(excludedPath => pathname.includes(excludedPath));
};

interface BrowserDetectProviderProps {
	children: ReactNode;
}

export const BrowserDetectProvider: React.FC<BrowserDetectProviderProps> = ({ children }) => {
	const isReactNativeWebView = !!(window as any).ReactNativeWebView;
	const [isBrowserSupported, setIsBrowserSupported] = useState<boolean>(true);

	useEffect(() => {
		const handleLocationChange = () => {
			const pathname = window.location.pathname;
			if (!isReactNativeWebView && (isMobile || !isChrome) && !isWhitelistedPath(pathname)) {
				setIsBrowserSupported(false);
			} else {
				setIsBrowserSupported(true);
			}
		};

		const _wr = (type: 'pushState' | 'replaceState') => {
			const orig = (history as any)[type];
			return function (this: History, ...args: any[]) {
				const rv = orig.apply(this, args);
				window.dispatchEvent(new Event('locationchange'));
				return rv;
			};
		};
		history.pushState = _wr('pushState');
		history.replaceState = _wr('replaceState');

		window.addEventListener('popstate', handleLocationChange);
		window.addEventListener('locationchange', handleLocationChange);

		handleLocationChange();

		return () => {
			window.removeEventListener('popstate', handleLocationChange);
			window.removeEventListener('locationchange', handleLocationChange);
		};
	}, [isReactNativeWebView]);

	return isBrowserSupported ? children : <UnsupportedBrowserAlert />;
};
